<template>
    <div class="body">
        <!-- 头部模块：墨绿色背景 + 金额 + 账单编号 -->
        <!-- 墨绿色背景区域 -->
        <div class="header-bg"></div>
        <div class="header-section">
            <!-- 内容区域 -->
            <div class="header-content">
                <div class="amount-value">￥{{ formatAmount(orderDetail.unpaidAmount || orderDetail.payableAmount || 0)
                    }}</div>
                <div class="amount-label">应缴金额</div>

            </div>
        </div>

        <!-- 订单信息卡片 -->
        <div class="order-info-card">
            <div class="info-row">
                <span class="info-label">账单编号</span>
                <span class="info-value">{{ orderDetail.studentBillDetailId }}</span>
            </div>
            <div class="info-row">
                <span class="info-label">出账日期</span>
                <span class="info-value">{{ orderDetail.createTime }}</span>
            </div>
            <div class="info-row">
                <span class="info-label">缴费截止日期</span>
                <span class="info-value">{{ orderDetail.endTime }}</span>
            </div>
            <div class="info-row">
                <span class="info-label">姓名</span>
                <span class="info-value">{{ studentName }}</span>
            </div>
            <div class="info-row">
                <span class="info-label">备注说明</span>
                <span class="info-value">{{ orderDetail.remark }}</span>
            </div>
            <div class="info-row" v-if="orderDetail.stable">
                <span class="info-label"></span>
                <span class="info-value">{{ orderDetail.stable }}</span>
            </div>
        </div>

        <!-- 费用详情卡片 -->
        <div class="fee-summary-card">
            <div class="fee-row">
                <span class="fee-label">合计</span>
                <span class="fee-value">￥{{ formatAmount(orderDetail.payableAmount || 0) }}</span>
            </div>
            <div class="fee-row">
                <span class="fee-label">累计缴费</span>
                <span class="fee-value fee-green">￥{{ formatAmount(orderDetail.payedAmount || 0) }}</span>
            </div>
            <div class="fee-row" v-if="orderDetail.refundedAmount">
                <span class="fee-label">累计退费</span>
                <span class="fee-value">￥{{ formatAmount(orderDetail.refundedAmount) }}</span>
            </div>
            <div class="fee-row total">
                <span class="fee-label">应缴金额</span>
                <span class="fee-value fee-red">￥{{ formatAmount(orderDetail.unpaidAmount || orderDetail.payableAmount
                    || 0) }}</span>
            </div>
        </div>

        <!-- 提示信息 -->
        <div class="tips-section">
            <p class="tips-text">温馨提示：支付完成后，预计3分钟到账！</p>
        </div>
        <div class="box2" v-if="orderDetail.commonCommodities">
            <div class="box2-2" v-for="(item, index) in orderDetail.commonCommodities" :key="index">
                <div class="name">{{ item.commodityName }}</div>
                <div class="user">{{ orderDetail.className }} {{ orderDetail.studentName }}</div>
                <div class="price1">
                    <span>￥{{ item.sellingPrice }}</span>
                    <span class="num">x1</span>
                </div>
            </div>
        </div>
        <!-- <div class="tip-box">
            温馨提示: 支付完成后，预计3分钟到账 !
        </div> -->
        <div class="payTypes">
            <div class="payType-title">支付方式</div>
            <div>
                <el-radio-group v-model="radio" style="width: 100%">
                    <div v-for="(item, idx) in payChannels" :key="idx">
                        <div class="payType-radio payType-bottom" v-if="item == '农行'">
                            <el-radio :label="1" class="custom-radio">
                                <el-image class="imgIcon" :src="require('../../assets/imgs/nonghang.png')"></el-image>
                                中国农业银行<span class="discount-tip" v-if="orderDetail.reductionPolicy && orderDetail.reductionPolicy.channels && orderDetail.reductionPolicy.channels.includes('农行掌银')">（{{ orderDetail.reductionPolicy.displayText }}）</span>
                            </el-radio>
                        </div>
                        <div class="payType-radio payType-bottom" v-if="item == '微信'">
                            <el-radio :label="2">
                                <el-image class="imgIcon" :src="require('../../assets/imgs/wxzf.jpeg')"></el-image>
                                微信支付 <span class="discount-tip" v-if="orderDetail.reductionPolicy && orderDetail.reductionPolicy.channels && orderDetail.reductionPolicy.channels.includes('微信支付')">（{{ orderDetail.reductionPolicy.displayText }}）</span>
                            </el-radio>
                        </div>
                        <div class="payType-radio payType-bottom" v-if="item == '聚合码支付'">
                            <el-radio :label="3" @click.native="toAggregatePay">
                                <el-image class="imgIcon" :src="require('../../assets/imgs/nonghang.png')"></el-image>
                                聚合码支付
                            </el-radio>
                        </div>
                    </div>

                </el-radio-group>
            </div>
        </div>

        <div class="btn" v-if="orderDetail.payedAmountType != 3">
            <van-button color="#0CB1FF" size="large" @click="partOrderClick" class="btn1"
                v-if="orderDetail.ctnTrue > 1">
                部分缴费
            </van-button>
            <van-button color="#49B78B" size="large" @click="orderAdd" class="btn2">确认支付</van-button>
        </div>
        <!--<div v-if="orderDetail.ctnTrue>1" class="btnsDiv">-->
        <!--<van-button color="#49B78B" size="large" @click="partOrderClick" class="btn1">-->
        <!--多次缴费-->
        <!--</van-button>-->
        <!--</div>-->


        <van-popup v-model="showPart" round class="partProup">
            <div class="partTitle">部分缴费
                <span class="tip">剩余次数（{{ orderDetail.ctnTrue }}）</span>
            </div>
            <div class="partContent">
                <van-field label="缴费" type="number" v-model="partPrice" class="field" maxlength="10" :border="false"
                    placeholder="请输入金额" />
            </div>

            <div class="partBtns">
                <div class="partBtn" @click="partOrderClose">取消</div>
                <div class="partBtn" @click="partOrderAdd">确定</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Notify } from 'vant';
import QRCode from 'qrcode';


export default {
    name: "studentBillDetailWx",

    data() {
        return {
            orderDetail: {},
            codeUrl: '',
            timer: '',
            imgLoading: false,
            studentName: '',
            qrCode: '',

            showPart: false,
            partPrice: '',
            orderCenterId: '',
            codeAmount: '',
            payChannels: [],
            radio: 2,
            openid: '',
        }
    },
    created() {
        // 优先从 sessionStorage 读取（回退页面时 params 可能为空）
        const savedDetail = sessionStorage.getItem('studentBillDetail')
        const savedStudentName = sessionStorage.getItem('studentName')
        
        if (this.$route.params && this.$route.params.detail) {
            this.orderDetail = this.$route.params.detail
            sessionStorage.setItem('studentBillDetail', JSON.stringify(this.orderDetail))
        } else if (savedDetail) {
            this.orderDetail = JSON.parse(savedDetail)
        } else {
            this.orderDetail = {}
        }
        
        if (this.$route.params && this.$route.params.studentName) {
            this.studentName = this.$route.params.studentName
            sessionStorage.setItem('studentName', this.studentName)
        } else if (savedStudentName) {
            this.studentName = savedStudentName
        } else {
            this.studentName = ''
        }
        
        this.openid = localStorage.getItem('openid')
        this.getSetting()
    },
    mounted() {

    },
    computed: {
        // showDiscount() {
        //     let discountSchoolIds = ['5040929423523841', '5040935616970753', '5040940548227073', '5040944657661953']
        //     let schoolId = this.orderDetail && this.orderDetail.schoolId ? String(this.orderDetail.schoolId) : ''
        //     return discountSchoolIds.indexOf(schoolId) > -1
        // }
    },
    methods: {
        getSetting() {
            let _this = this
            let url = '/zuhu1/api-dashboard/studentBill/settings_G'
            let query = {
                schoolId: _this.orderDetail.schoolId
                //schoolId:'1445629640146945'
            }
            this.$api.post(url, query, function (result) {
                let data = result.data.data || {}
                let payChannels = data.payChannels || []
                let defaultChannel = data.defaultChannel || ''
                if(defaultChannel == '农行'){
                    _this.radio = 1
                }
                 if(defaultChannel == '微信'){
                    _this.radio = 2
                }
                 if(defaultChannel == '聚合码支付'){
                    _this.radio = 3
                    _this.toAggregatePay()
                }
                _this.payChannels = payChannels
            })
        },
        getResult() {
            let _this = this
            let url = '/zuhu1/api-dashboard/studentBill/result2'
            let query = {
                studentBillDetailId: this.orderDetail.studentBillDetailId,
                orderCenterId: this.orderCenterId
            }
            this.$api.post(url, query, function (result) {
                let datas = result.data.data || []
                let obj = datas[0] || {}
                let payStatus = obj.payStatus
                _this.codeAmount = obj.amount
                if (payStatus == 1) {
                    _this.$router.push({
                        name: 'billPaySuccess',
                        query: { amount: obj.amount, thirdOrderNo: obj.thirdOrderNo, successTime: obj.successTime, }
                    })
                }
            })
        },
        /**
         * 格式化金额，保留两位小数
         */
        formatAmount(amount) {
            if (typeof amount === 'number') {
                return amount.toFixed(2)
            }
            return '0.00'
        },

        start() {
            let orderCenters = this.orderDetail.orderCenters || []
            if (orderCenters.length > 0) {
                this.getResult()
                this.timer = setInterval(this.getResult, 2000);
            }
        },

        toAggregatePay() {
            let _this = this
            let url = '/zuhu1/api-dashboard/studentBill/refresh'
            let query = {
                studentBillDetailId: this.orderDetail.studentBillDetailId
            }
            this.$api.post(url, query, function (result) {
                let orderCenters = result.data.orderCenters || []
                _this.orderDetail.orderCenters = orderCenters
                _this.$router.push({
                    name: 'studentBillDetail',
                    params: { detail: _this.orderDetail, studentName: _this.studentName }
                })
            })
        },
        partOrderClick() {
            this.showPart = true
        },
        partOrderClose() {
            this.showPart = false
            this.partPrice = ''
        },
        partOrderAdd() {
            let _this = this
            if (!_this.partPrice) {
                // Notify({type: 'warning', message: '请输入缴费金额！'});
                this.$message({
                    type: 'warning',
                    message: '请输入缴费金额!'
                });
                return
            }
            if (_this.orderDetail.payedCnt >= _this.orderDetail.cnt) {
                // Notify({type: 'warning', message: '超过最大缴费次数'});
                this.$message({
                    type: 'warning',
                    message: '超过最大缴费次数!'
                });
                return
            }

            let parice = (_this.orderDetail.payableAmount - _this.orderDetail.payedAmount + _this.orderDetail.refundedAmount).toFixed(2)

            if (_this.partPrice * 1 > parice * 1) {
                // Notify({type: 'warning', message: '请输入正确缴费金额！'});
                this.$message({
                    type: 'warning',
                    message: '请输入正确缴费金额!'
                });
                return
            }
            if (this.radio == 1) {
                let _this = this
                let url = '/zuhu1/api-dashboard/orderCenter/search_bill'

                let query = {
                    amount: _this.partPrice,
                    studentBillDetailId: _this.orderDetail.studentBillDetailId,
                    payType: 1,
                    schoolId: _this.orderDetail.schoolId,
                }

                this.$api.post(url, query, function (res) {
                    if (res.data.result == "success") {
                        let dynamicData = res.data.dynamicData
                        window.location.href = 'https://wx.abchina.com/webank/main-view/openTagForId?id=k0WoqSSxzqs%3D&dynamicData=' + dynamicData;
                    }
                })
            } else {
                let url = '/zuhu1/api-dashboard/orderCenter/wx_bill'
                if (!_this.openid) {
                    _this.$message({
                        type: 'warning',
                        message: '未获取到openid，请从公众号菜单访问!'
                    })
                    return
                }
                let query = {
                    amount: _this.partPrice,
                    studentBillDetailId: _this.orderDetail.studentBillDetailId,
                    payType: 1,
                    schoolId: _this.orderDetail.schoolId,
                    openid: _this.openid
                }
                this.$api.post(url, query, function (result) {
                    _this.partOrderClose()

                    let JSAPI = result.data.JSAPI
                    // 微信支付
                    WeixinJSBridge.invoke('getBrandWCPayRequest', {
                        appId: JSAPI.sub_appId,   // 上一步得到的参数
                        nonceStr: JSAPI.nonceStr, // 上一步得到的参数
                        package: JSAPI.package,   // 上一步得到的参数
                        signType: JSAPI.signType, // 上一步得到的参数
                        timeStamp: JSAPI.timeStamp,   // 上一步得到的参数
                        paySign: JSAPI.paySign    // 上一步得到的参数
                    }, res => {
                        // 根据get_brand_wcpay_request的值判断支付状态
                        if (res.err_msg === "get_brand_wcpay_request:ok") {
                            // ok：支付成功
                            this.$message.success('支付成功!')
                            setTimeout(() => {
                                window.location.href = `https://wxztc.com.cn/#/studentBill?amount=${parice}`
                            })
                        } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                            // cancel：用户取消支付
                            // 取消支付要做的事儿，比如进入重新支付步骤等
                            this.$message.info('用户取消支付!')

                        } else if (res.err_msg === "get_brand_wcpay_request:fail") {
                            // fail：支付失败
                            // 支付失败要做的事儿，比如进入支付失败步骤等
                            this.$message.error(`支付失败:${res.err_msg}`)

                        }
                    })

                })
            }

        },

        orderAdd() {
            if (this.radio == 1) {
                let _this = this
                let url = '/zuhu1/api-dashboard/orderCenter/search_bill'

                let parice = (_this.orderDetail.payableAmount - _this.orderDetail.payedAmount + _this.orderDetail.refundedAmount).toFixed(2)

                let query = {
                    amount: parice,
                    studentBillDetailId: _this.orderDetail.studentBillDetailId,
                    payType: 1,
                    schoolId: _this.orderDetail.schoolId,
                }

                this.$api.post(url, query, function (res) {
                    if (res.data.result == "success") {
                        let dynamicData = res.data.dynamicData
                        window.location.href = 'https://wx.abchina.com/webank/main-view/openTagForId?id=k0WoqSSxzqs%3D&dynamicData=' + dynamicData;
                    }
                })
            } else {
                let _this = this
                let url = '/zuhu1/api-dashboard/orderCenter/wx_bill'

                let parice = (_this.orderDetail.payableAmount - _this.orderDetail.payedAmount + _this.orderDetail.refundedAmount).toFixed(2)

                if (!_this.openid) {
                    _this.$message({
                        type: 'warning',
                        message: '未获取到openid，请从公众号菜单访问!'
                    })
                    return
                }
                let query = {
                    amount: parice,
                    studentBillDetailId: _this.orderDetail.studentBillDetailId,
                    payType: 1,
                    schoolId: _this.orderDetail.schoolId,
                    openid: _this.openid
                }

                this.$api.post(url, query, function (res) {
                    if (res.data.result == "success") {
                        let JSAPI = res.data.JSAPI
                        // 微信支付
                        WeixinJSBridge.invoke('getBrandWCPayRequest', {
                            appId: JSAPI.sub_appId,   // 上一步得到的参数
                            nonceStr: JSAPI.nonceStr, // 上一步得到的参数
                            package: JSAPI.package,   // 上一步得到的参数
                            signType: JSAPI.signType, // 上一步得到的参数
                            timeStamp: JSAPI.timeStamp,   // 上一步得到的参数
                            paySign: JSAPI.paySign    // 上一步得到的参数
                        }, res => {
                            // 调用后要做的事儿
                            // codes...

                            // 根据get_brand_wcpay_request的值判断支付状态
                            if (res.err_msg === "get_brand_wcpay_request:ok") {
                                // ok：支付成功
                                // 支付成功要做的事儿，比如跳转支付完成后的页面等
                            } else if (res.err_msg === "get_brand_wcpay_request:cancel") {
                                // cancel：用户取消支付
                                // 取消支付要做的事儿，比如进入重新支付步骤等
                            } else if (res.err_msg === "get_brand_wcpay_request:fail") {
                                // fail：支付失败
                                // 支付失败要做的事儿，比如进入支付失败步骤等
                            }
                            // 注：使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok,但并不保证它绝对可靠。
                        })

                    }
                })
            }

        },


    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
}
</script>

<style scoped>
.body {
    font-size: 16px;
    background: #f5f5f5;
    width: 100%;
    min-height: 100vh;
    padding-bottom: 100px;
    /* 为底部固定按钮留出空间 */
    box-sizing: border-box;
}

/* 头部模块 */
.header-section {
    position: relative;
    margin: 0 15px 10px;
    border-radius: 8px;
    overflow: hidden;
}

/* 墨绿色背景区域 */
.header-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 120px;
    background-color: #31BDB4;
    /* 墨绿色 */
    border-radius: 8px 8px 0 0;
}

/* 头部内容区域 */
.header-content {
    position: relative;
    z-index: 1;
    padding: 15px 15px 5px;
    background-color: #fff;
    border-radius: 8px;
    margin-top: 40px;
}

.amount-value {
    font-size: 48px;
    font-weight: 700;
    color: #e53935;
    line-height: 1.2;
    text-align: center;
    margin-bottom: 8px;
}

.amount-label {
    font-size: 14px;
    color: #999;
    text-align: center;
    display: block;
    margin-bottom: 15px;
}

/* 账单编号行 */
.bill-id-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    border-top: 1px solid #f5f5f5;
}

.bill-id-row .info-label {
    font-size: 14px;
    color: #999;
    width: 100px;
}

.bill-id-row .info-value {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    flex: 1;
    text-align: right;
    margin-left: 10px;
}

/* 订单信息卡片 */
.order-info-card {
    background-color: #fff;
    margin: 0 15px 10px;
    border-radius: 8px;
    padding: 15px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f5f5f5;
}

.info-row:last-child {
    border-bottom: none;
}

.info-label {
    font-size: 14px;
    color: #999;
    width: 100px;
}

.info-value {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    flex: 1;
    text-align: right;
    margin-left: 10px;
}

/* 费用详情卡片 */
.fee-summary-card {
    background-color: #fff;
    margin: 0 15px 10px;
    border-radius: 8px;
    padding: 15px;
}

.fee-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid #f5f5f5;
}

.fee-row:last-child {
    border-bottom: none;
}

.fee-row.total {
    padding-top: 15px;
    margin-top: 5px;
    border-top: 1px dashed #ddd;
}

.fee-label {
    font-size: 14px;
    color: #666;
}

.fee-value {
    font-size: 14px;
    color: #333;
}

.fee-value.fee-green {
    color: #07c160;
}

.fee-value.fee-red {
    color: #e53935;
    font-weight: 600;
    font-size: 16px;
}

/* 提示信息 */
.tips-section {
    margin: 0 15px 10px;
    padding: 12px 15px;
    background-color: #fffef5;
    border-radius: 8px;
    border-left: 4px solid #ffb300;
}

.tips-text {
    font-size: 13px;
    color: #999;
    margin: 0;
    line-height: 1.5;
}

.box1 {
    background: white;
    padding: 10px 20px;
}

.box1 span {
    display: inline-block;
    padding: 0 10px;
    color: #9A9A9A;
}

.box-title {
    color: #101010 !important;
    width: 100px;
    text-align: right;
}

.box1-1 {
    border-bottom: 1px solid #BBBBBB;
    height: 40px;
    line-height: 40px;
}

.box1-2 {
    border-bottom: 1px solid #BBBBBB;
    padding: 5px 0;
}

.box1-2>div {
    min-height: 30px;
    line-height: 30px;
    display: flex;
    flex-wrap: wrap;
}

.box1-2 span {
    display: inline-block;
}

.box1-3 {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.box2 {
    background: white;
    /*display: flex;*/
    margin: 10px 0;
    padding: 20px;
}


.box2-2 {
    flex: 1;
    padding: 10px;
    border-bottom: 1px solid #BBBBBB;
}

.box2-2>div {
    height: 30px;
    line-height: 30px;
}

.name {
    color: #101010;
    font-weight: bold;
}

.user {
    color: #101010;
}

.price {
    color: #EA0909 !important;
}

.price1 {
    color: #C5B9B9;
}

.num {
    float: right;
}

.red {
    color: #EA0909 !important;
}

.green {
    color: #3CC878 !important;
}

.codeBox {
    width: 120px;
    height: 120px;
}

.codeBody {
    display: flex;
    padding: 10px 10px 10px 10px;
    background: white;
    margin-top: 10px;
}

.num1Tip {
    font-size: 14px;
}

.num1 {
    color: red;
    font-size: 28px;
}

.num2 {
    font-size: 14px;
}

.p1 {
    padding: 5px 0;
}

.p1>span {
    padding: 0 10px;
}

.p2 {
    padding: 0 10px;
    font-size: 14px;
    display: flex;
    align-items: center;
    height: 30px;
}

.p2>span {
    padding: 0 10px;
}

.p3 {
    color: #BFB1B1;
    font-size: 14px;
    padding: 10px;
}

.btns {
    text-align: center;
    margin-top: 100px;
}

.btn {
    width: 90%;
    position: fixed;
    left: 5%;
    bottom: 20px;
    display: flex;
}

.btn1 {
    flex: 1;
    margin-right: 10px;
}

.btn2 {
    flex: 2;
}

.tip {
    margin-top: 10px;
    padding: 10px 20px;
    color: #101010;
    background: white;
    font-weight: bold;
}

.refresh {
    color: #4B9DFD;
}

.qrCodeError {
    font-size: 14px;
    color: red;
    margin-top: 10px;
    padding: 10px 20px;
    background: white;
}

.partTitle {
    text-align: center;
    padding: 0 0 10px 0;
    font-size: 18px;
    font-weight: bold;
}

.partContent {
    padding: 20px 0;
}

.partBtns {
    display: flex;
    margin-bottom: -20px;
}

.partBtn {
    flex: 1;
    text-align: center;
    padding: 20px 0;
    border-top: 1px solid #ebedf0;
    border-right: 1px solid #ebedf0;
}

.partProup {
    width: 90%;
    padding: 20px 0;
}

.tip {
    font-size: 14px;
    color: #646566;
}

.btnsDiv {
    width: 90%;
    margin: 40px auto;
}

.payTypes {
    width: 95%;
    margin: 20px auto 100px;
    border-radius: 10px;
    background: white;
}

.payType-title {
    border-bottom: 1px solid #cccccc;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    color: #292929;
}

.payType-bottom {
    border-bottom: 1px solid #cccccc;
}

.payType-radio /deep/ .el-radio {
    width: 100%;
    padding: 0 20px;
    height: 50px;
    line-height: 50px;
    box-sizing: border-box;
}

.payType-radio /deep/ .el-radio__label {
    display: flex;
    font-size: 16px;
    align-items: center;
}

.payType-radio /deep/ .el-radio__input {
    float: right;
    display: flex;
    align-items: center;
    height: 100%;
}


.imgIcon {
    width: 25px;
    height: 25px;
    padding: 0 5px;
}

.discount-tip {
    color: #EA0909;
    margin-left: 5px;
}

.tip-box {
    width: 95%;
    color: #84B0F7;
    background: white;
    height: 30px;
    line-height: 30px;
    margin: 4px auto;
    padding: 0 10px;
    font-size: 14px;
    font-weight: bold;
}

.black {
    color: black !important;
}

/* 底部固定按钮区域 */
.btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    gap: 10px;
    padding: 10px 15px;
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
    background-color: #fff;
    border-top: 1px solid #eee;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    z-index: 100;
}

.btn1 {
    flex: 1;
    border-radius: 8px;
    background-color: #fff;
    color: #49B78B;
    border: 1px solid #49B78B;
}

.btn2 {
    flex: 2;
    border-radius: 8px;
    background-color: #49B78B;
    color: #fff;
}
</style>
